export default function transformPipelineTagsToChips(pipelineTags) {
  return pipelineTags.map(({ tag }) => ({
    id: tag.id,
    label: tag.label,
  }));
}
